import { GenericErrorScreenComponent } from 'components/messages/GenericErrorScreen';
import { LoadingScreenComponent } from 'components/LoadingScreen';
import { FLATTEN_RIGHTS } from 'common/helpers/DrmHelper';
import HttpService from 'common/services/HttpService';
import React, { useState, useEffect } from 'react';
import { UserDrm } from 'common/stores/UserDrm';


export function UserDrmComponent({ children }) {
    const [drm, setDrm] = useState({ list: [], map: {}, loading: true });
    const { list: { length } = {}, loading } = drm;

    useEffect(() => {
        getRights();
    }, []);

    async function getRights() {
        if(length) {
            return;
        };

        try {
            const { body: list = [] } = await HttpService.getRights({ rights: FLATTEN_RIGHTS });
            const map = list.reduce((output, right) => ({ ...output, [right]: true }), {});
    
            setDrm({ list, map, loading: false });
        } catch (error) {
            console.log(error);

            setDrm({ error: true, list: [], map: {}, loading: false });
        };
    };

    function matchRights({ rights = [] }) {
        const { map } = drm;
        const matchedRights = rights.filter(right => map[right]);
        
        return matchedRights.length >= rights.length;
    };

    return (
        <UserDrm.Provider value={{ drm, matchRights }}>

            {!loading ? drm.error ? (
                <GenericErrorScreenComponent withHeaderBar={false} />
            ) : length ? children : (
                <GenericErrorScreenComponent className="page-301" message="Sem Acesso" withHeaderBar={false} />
            ) : (
                <LoadingScreenComponent />
            )}
        </UserDrm.Provider>
    );
};